import { eventBus } from '../../core/events';
import type { StepRegistry } from '../StepRegistry';
import { wait } from './utils';

export function registerNotificationSteps(registry: StepRegistry): void {
  registry.register('notification', async (step) => {
    eventBus.emit('notification', step.params);
    await wait(step.duration);
  });
}
